"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var checkout_exports = {};
__export(checkout_exports, {
  Checkout: () => Checkout
});
module.exports = __toCommonJS(checkout_exports);
var Checkout;
((Checkout2) => {
  let Load;
  ((Load2) => {
    Load2.path = "checkout/load";
  })(Load = Checkout2.Load || (Checkout2.Load = {}));
  let Login;
  ((Login2) => {
    Login2.path = "checkout/login";
  })(Login = Checkout2.Login || (Checkout2.Login = {}));
  let Logout;
  ((Logout2) => {
    Logout2.path = "checkout/logout";
  })(Logout = Checkout2.Logout || (Checkout2.Logout = {}));
  let SaveBillingAddress;
  ((SaveBillingAddress2) => {
    SaveBillingAddress2.path = "checkout/saveBillingAddress";
  })(SaveBillingAddress = Checkout2.SaveBillingAddress || (Checkout2.SaveBillingAddress = {}));
  let SaveCustom;
  ((SaveCustom2) => {
    SaveCustom2.path = "checkout/saveCustom";
  })(SaveCustom = Checkout2.SaveCustom || (Checkout2.SaveCustom = {}));
  let SaveEmail;
  ((SaveEmail2) => {
    SaveEmail2.path = "checkout/saveEmail";
  })(SaveEmail = Checkout2.SaveEmail || (Checkout2.SaveEmail = {}));
  let SavePayment;
  ((SavePayment2) => {
    SavePayment2.path = "checkout/savePayment";
  })(SavePayment = Checkout2.SavePayment || (Checkout2.SavePayment = {}));
  let SaveShippingAddress;
  ((SaveShippingAddress2) => {
    SaveShippingAddress2.path = "checkout/saveShippingAddress";
  })(SaveShippingAddress = Checkout2.SaveShippingAddress || (Checkout2.SaveShippingAddress = {}));
  let SaveShippingMethod;
  ((SaveShippingMethod2) => {
    SaveShippingMethod2.path = "checkout/saveShippingMethod";
  })(SaveShippingMethod = Checkout2.SaveShippingMethod || (Checkout2.SaveShippingMethod = {}));
  let Submit;
  ((Submit2) => {
    Submit2.path = "checkout/submit";
  })(Submit = Checkout2.Submit || (Checkout2.Submit = {}));
  let Success;
  ((Success2) => {
    Success2.path = "checkout/success";
  })(Success = Checkout2.Success || (Checkout2.Success = {}));
  let PaymentCapture;
  ((PaymentCapture2) => {
    PaymentCapture2.path = "checkout/paymentCapture";
  })(PaymentCapture = Checkout2.PaymentCapture || (Checkout2.PaymentCapture = {}));
  let PaymentCancel;
  ((PaymentCancel2) => {
    PaymentCancel2.path = "checkout/paymentCancel";
  })(PaymentCancel = Checkout2.PaymentCancel || (Checkout2.PaymentCancel = {}));
})(Checkout || (Checkout = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Checkout
});
